module.exports = __webpack_public_path__ + "img/hero-fodij.fe1ba3c4.png";